export default __webpack_public_path__ + "static/media/rishi kumar.d05e2498.jpg";